import { render, staticRenderFns } from "./RegistrationSelect.vue?vue&type=template&id=c37b8bec&scoped=true"
import script from "./RegistrationSelect.vue?vue&type=script&lang=js"
export * from "./RegistrationSelect.vue?vue&type=script&lang=js"
import style0 from "./RegistrationSelect.vue?vue&type=style&index=0&id=c37b8bec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b8bec",
  null
  
)

export default component.exports